<template>
  <div class="full-screen" style="z-index: 7;">
    <top id="top-nav" :title="bookTitle" :key="`${bookInfo.bookId}-home`"></top>

    <div :id="`scroll-div-book-home-${this.$route.params.id}`" class="main" style="height: calc(100% - 2rem); overflow: auto; margin-bottom: 0; padding-top: 2rem;">
      <div class="no-hairlines">

        <div class="bookmain">
          <div class="cover">
            <img style="width: 100%;" :bookid="bookInfo.bookId" :booktitle="bookTitle" :chapternum="0" :imgpath="bookInfo.horiCover" :zoom="2000" v-lazy="require('../../../assets/images/loading_ho.jpg')">
          </div>
          <div class="bkname">
            <h3>
              <span>{{bookInfo.title}}</span>
              <span :class="{'tag-green': bookInfo.publishStatus === 'finish', 'tag-red': bookInfo.publishStatus === 'serialize'}">{{bookInfo.publishStatus === 'serialize' ? '连载中' : bookInfo.publishStatus === 'finish' ? '已完结' : ''}}</span>
            </h3>
            <div class="info">
              <span>
							  <label>类型: </label>{{bookInfo.categoryName}}
						  </span>
              <span >
							  <label>推荐指数: </label>{{bookInfo.recommend}}
						  </span>
              <span>
							  <label>阅读量: </label>{{bookInfo.readCount}}
						  </span>
            </div>
          </div>

          <div class="btnbox-bk">
            <div class="col"><a :class="addedToShelf ? 'btn btn-n' : 'btn btn-o'" @click="addShelf">{{addedToShelf ? '移除收藏' : '加入收藏'}}</a></div>
            <div class="col"><a class="btn btn-f" @click="toReadHandler('history')">开始阅读</a></div>
          </div>

          <p class="book-desc">{{bookInfo.abstractContent}}</p>

        </div>

        <div v-for="(chapter, index) in chapters.slice(0,2)" :key="chapter.number" v-if="chapter.price === 0" class="item-link" @click="toRead(chapter.number)">
          <h5 class="t2">免费</h5>
          <div class="item-after"><span class="margin-right-sm">{{chapter.title}}</span></div>
        </div>

        <div class="item-link" @click="toCatalog">
          <h5 class="t2">目录</h5>
          <div class="item-after">共{{bookInfo.chapterCount}}话</div>
        </div>
      </div>

      <books-small title="同类推荐" :show-more="false" :books="books"></books-small>

      <div id="show-history-modal" v-if="showModal && !!history" class="fixed-confirm" style="display: block;">
        <div class="fixed-c">
          <h3>上次阅读到第{{history ? history.number : ''}}话， 是否继续阅读？</h3>
          <div class="btnbox">
            <button class="btn" type="button" @click="toReadHandler('history')">确定</button>
            <button class="btn close" type="button" @click="hideModal">取消</button>
          </div>
        </div>
      </div>
    </div>


    <div class="fixed-cz" style="z-index: 10" @click="toPurchase"><span>充值</span></div>

  </div>
</template>

<script>
  import BooksSmall from '@/components/share/books-small'
  import BookTop from '@/components/layer2/book/book-top'
  import bookService from "../../../services/bookService";
  import shelfService from "../../../services/shelfService";
  import userService from "../../../services/userService";
  import kkUtil from "../../../assets/js/kk-util";
  import listService from "../../../services/listService";


  export default {
    name: "book-home",
    data() {
      return {
        componentName: '',
        bookInfo: {},
        chapters: [],
        lastChapter: {},
        recommends: [],
        addedToShelf: false,
        history: undefined,
        showModal: true,
        bookTitle: '',
        target: 1,
        category: null,
        books: [],
      }
    },
    methods: {
      toPurchase() {
        this.$router.isBack = false;
        this.$router.push('/purchase')
      },
      isShowHistory() {
        //console.log('in home page, isBack is : ', this.$router.isBack);
        this.showModal = !this.$router.isBack;
        this.$router.isBack = true;
      },
      toCatalog() {
        this.$router.isBack = false;
        this.$router.push({path: `${this.$route.path}/catalog`, query: {title: this.bookInfo.title}})
      },
      getBookDetail() {
        if (kkUtil.isEmpty(this.$route.params.id)){
          this.$router.isBack = true;
          this.$router.go(-1);
        }else {
          bookService.getDetail(this.$route.params.id)
            .then(res => {
              let data = res.data;
              this.bookInfo = data.book;
              this.chapters = data.chapterList;
              this.lastChapter = data.lastChapter;
              this.recommends = data.recommendList;
              this.bookTitle = data.book.title;
              this.category = data.book.category
              this.target = Math.ceil(Math.random() * data.categoryPageCount);
              if(this.target <= 0){this.target = 1}
              this.isAddedToShelf();
              this.getBooks(this.target)
            })
        }
      },
      getPriceText(price) {
        if (price === 0 || price === '0') {
          return '免费'
        } else {
          return `${price}金币`
        }
      },
      addShelf() {
        this.addedToShelf = shelfService.addShelf(this.bookInfo);
      },
      isAddedToShelf() {
        let shelfBook = shelfService.getShelf().find(item => {
          return item.title === this.bookInfo.title
        });
        this.addedToShelf = !!shelfBook;
      },
      toReadHandler(type) {
        if (type === 'history') {
          this.toRead(this.history ? this.history.number : 1);
        } else if (type === 'last') {
          this.toRead(this.lastChapter.number);
        }
      },
      toRead(number) {
        number = parseInt(number);
        this.$router.isBack = false;
        this.$router.push({path: `/book/read/${this.bookInfo.bookId}/${number}`});
        //this.$router.push({path: `/book/read/${this.bookInfo.bookId}/${number}`, query: {title: this.bookInfo.title, title2: this.chapters.find(item => item.number === number).title}})
        shelfService.addHistory(this.bookInfo, number);
      },
      getHistory(bookId) {
        this.history = shelfService.getHistoryById(parseInt(bookId));
      },
      hideModal() {
        let obj = document.getElementById('show-history-modal');
        obj.style.opacity = 1;
        this.fadeOut(obj);
      },
      fadeOut(obj) {
        obj.style.opacity -= 0.05;
        if (obj.style.opacity > 0) {
          setTimeout(() => {
            this.fadeOut(obj)
          }, 15)
        } else {
          this.showModal = false;
        }
      },
      getBooks(target) {
        listService.getBooks(this.category, target, 'all')
          .then(res => {
            if (res.result) {
              if (res.data.totalPage == 0 || this.currentPage >= res.data.totalPage) {
                this.books = [];
              }else{
                this.books = res.data.bookList.slice(0,6);
              }
              console.log(this.books)
            }
          })
      },

    },
    components: {
      'books-small': BooksSmall,
      top: BookTop
    },
    mounted() {
      userService.register();

      this.componentName = this.$route.path;
      //console.log(this.componentName, this.$store.state.pageState[this.componentName]);
      if(this.$store.state.pageState[this.componentName] && this.$router.isBack) {
        Object.assign(this.$data, this.$store.state.pageState[this.componentName].data);
        this.showModal = false;
        setTimeout((vue = this) => {
          let scrollDiv = document.getElementById(`scroll-div-book-home-${this.$route.params.id}`);
          scrollDiv.scrollTop = vue.$store.state.pageState[vue.componentName].top;
        }, 5);
      }
      else {
        this.isShowHistory();
        this.getBookDetail();
      }
      this.$router.isBack = true;
      this.getHistory(this.$route.params.id);

    },
    beforeDestroy() {
      let scrollDiv = document.getElementById(`scroll-div-book-home-${this.bookInfo.bookId}`);
      let state = {};
      state[this.componentName] = {data: this.$data, top: scrollDiv.scrollTop};
      this.$store.commit('saveState', state);
    }
  }
</script>

<style scoped>
  * {
    z-index: 7;
  }
</style>



// WEBPACK FOOTER //
// src/pages/layer2/book/home.vue